var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('span',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.t1))]),(_vm.t2)?_c('span',[_c('v-icon',{domProps:{"textContent":_vm._s('mdi-arrow-right')}})],1):_vm._e(),(_vm.t2)?_c('span',[_vm._v(_vm._s(_vm.t2))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }